import sharedConfig, { ENVIRONMENTS } from './shared';

import type { Config } from './env';

const { app, ...shared } = sharedConfig;

const configCatKey = process.env.REACT_APP_EUD_CONFIG_CAT_KEY || '';
const recaptchaSiteKey = process.env.REACT_APP_EUD_RECAPTCHA_SITE_KEY || '';

const configBase = {
  app: {
    ...app,
    catalogName: 'Guia Digital',
    name: 'Eudora',
    slugname: 'eudora',
    gtm: 'GTM-56L8KFR',
    short: 'eud',
    url: 'https://hrepresentante.eudora.com.br/',
    fallbackUrl: 'https://herepresentante.eudora.com.br',
    orderTrackingUrl: 'https://herepresentante.eudora.com.br/pedidos/rastreador/',
    paymentUrl:
      'https://herepresentante.eudora.com.br/Pedidos/RedirectToGeraByPage?page=ConsultarPedidos',
    paymentVDFUrl: 'https://hrevendedor.boticario.com.br/pedidos?tab=a-pagar',
    mfLink: 'https://hreseller-self-service-mf.eudora.com.br',
  },
  configCat: {
    key: configCatKey,
  },
  prismic: {
    accessToken: '',
    apiUrl: 'https://re-eudora.cdn.prismic.io/api/v2',
  },
  bff: {
    applicationID: '862d5019-ce14-440b-9f10-a893c620849b',
    baseUrl: process.env.REACT_APP_BFF_URL || '',
    clientID: 'aimzXUSpTyqyhnB9f9oVdhhrroBP0wQM',
  },
  communication: {
    message:
      'Olá, estava no Portal do Representante e gostaria de falar com a Central de Atendimento ao Representante Eudora',
    openingHours: 'Atendimento de segunda a sexta das 9h às 18h e sábado das 9h às 16h',
    phoneNote:
      'Ligação gratuita de qualquer lugar do país tanto de telefone fixo quanto de celular',
    phone: '0800 727 4535',
    title: 'Fale com Eudora',
    userNamingConvention: {
      singular: 'Representante',
      plural: 'Representantes',
    },
    whatsapp: '0800 744 0080',
  },
  registration: {
    infoResellerPlace: 'Ciclo, Espaço de Representantes (ER), e Supervisão',
  },
  starlink: {
    baseUrl: 'https://vd-starlink-assets.grupoboticario.com.br',
  },
  privacyPolicies: {
    title: 'Política de Privacidade',
    site: 'https://privacidade.grupoboticario.com.br/politica-de-privacidade/',
  },
  google: {
    recaptcha: {
      siteKey: recaptchaSiteKey,
    },
  },
  ...shared,
};

if (process.env.NODE_ENV === ENVIRONMENTS.PRODUCTION) {
  configBase.app.url = 'https://representante.eudora.com.br/';
  configBase.app.fallbackUrl = 'https://representante.eudora.com.br';
  configBase.app.paymentUrl =
    'https://representante.eudora.com.br/Pedidos/RedirectToGeraByPage?page=ConsultarPedidos';
  configBase.app.paymentVDFUrl = 'https://revendedor.boticario.com.br/pedidos?tab=a-pagar';
  configBase.bff.clientID = 'Sc4GOQheqXui4QXA7J4xkoWptjZVaatn';
  configBase.app.mfLink = 'https://reseller-self-service-mf.eudora.com.br';
}

configBase.app.orderTrackingUrl = `${configBase.app.fallbackUrl}/pedidos/rastreador/`;

const config: Config = {
  ...configBase,
};

export default config;
